import { useListProjectContactsQuery } from "@generated";
import { RootState } from "@reducers/rootReducer";
import { useSelector } from "react-redux";
import { Contact, ContactType, CONTACT_TYPE_LABELS } from "../types/Contact";

interface UseListContactsArgs {
  projectId: string;
  page?: { number?: number; size?: number };
}

const useListContacts = ({ projectId, page }: UseListContactsArgs) => {
  const { accountSlug } = useSelector((state: RootState) => state.slug);

  const { data, error, isLoading, isFetching, refetch } =
    useListProjectContactsQuery({
      slug: accountSlug,
      filter: { project: projectId },
      page: page || { size: 250 },
    });

  const contacts: Contact[] =
    data?.data?.map((c: any) => ({
      id: String(c.id),
      name: c.attributes?.name || "",
      title: c.attributes?.title || "",
      email: c.attributes?.email || "",
      phone: c.attributes?.phone || "",
      contactType: c.attributes?.["contact-type"] || "customer_contact",
      projectVariables: c.attributes?.["project-variables"] || [],
    })) || [];

  const pageMeta = {
    pageCount: data?.meta?.["page-count"] || 1,
    recordCount: data?.meta?.["record-count"] || 0,
  };

  return {
    contacts,
    contactsError: error,
    contactsLoading: isLoading,
    contactsFetching: isFetching,
    pageMeta,
    refetch,
  };
};

export default useListContacts;
